import * as React from "react";
import { FormControl, Grid, MenuItem, Paper, Select, TextField, Typography, InputLabel } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import RenewalMonthsSelector from "./RenewalMonthsSelector";
import { currencies } from "../constants";
import { getCurrencySymbol } from "../helpers/CurrencyHelper";

class AssetDataFeesInternational extends React.Component<any, any> {
    public render() {
        const {
            agreement: {
                states: [state],
                data: {entity},
            },
            fees,
            classes
        } = this.props;

        if (!Object.keys(fees).length) {
            return null;
        }

        const currencySelector =
            <Paper className={classes.paper}>
                <Grid id='fee-currency-selection' container alignItems="center" spacing={24}>
                    <Grid item>
                        <Typography variant="subheading">
                            Fees due in:
                        </Typography>
                    </Grid>
                    <Grid item>
                        <FormControl>
                            <InputLabel>Currency</InputLabel>
                            <Select
                                id="currency"
                                value={this.props.currency}
                                onChange={this.props.onChangeCurrency}
                                className={classes.dropDown}
                                disabled={!this.props.configuration[state.id].sendFees}
                                style={{ width: 195}}
                            >
                                {Object.keys(currencies).map(currency => (
                                    <MenuItem key={currency} value={currency}>
                                        {currency}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Paper>;

        const tableHeader =
            <>
                <Grid item xs={3}>
                    <Typography variant="caption" className={classes.feeHeading}>
                        Fee description
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="caption" className={classes.feeHeading}>
                        Data fee ({entity.name})
                    </Typography>
                </Grid>
                <Grid item xs={6}/>
            </>;
        
        const tableRows = Object.values(fees).map((fee: any) => (
            <React.Fragment key={fee.id}>
                <Grid item xs={3}>
                    <Typography>{fee.description}</Typography>
                </Grid>
                <Grid item xs={3}>
                    {fee.data !== undefined ? (
                        <TextField
                            id={fee.id}
                            value={fee.data}
                            type="number"
                            onChange={this.props.onFeeUpdate}
                            InputProps={{
                                startAdornment:
                                    <InputAdornment position="start">
                                        {getCurrencySymbol(this.props.currency)}
                                    </InputAdornment>,
                            }}
                            disabled={!this.props.configuration[state.id].sendFees}
                            fullWidth
                        />
                    ) : null}
                </Grid>
                <Grid item xs={6}/>
            </React.Fragment>
        ));


        return (
            <React.Fragment>
                <Typography variant="title" className={classes.title}>
                    Fees
                </Typography>
                
                {currencySelector}

                <Paper className={classes.paper}>
                    <Grid container spacing={24}>
                        {tableHeader}
                        {tableRows}
                        <Grid item xs={3}>
                            <RenewalMonthsSelector
                                onChangeDurationMonths={this.props.onChangeDurationMonths}
                                agreement={this.props.agreement}
                                durationMonths={this.props.durationMonths}
                                configuration={this.props.configuration}
                                />
                        </Grid>
                    </Grid>
                </Paper>
            </React.Fragment>
        );
    }
}

export default AssetDataFeesInternational;


// WEBPACK FOOTER //
// ./src/modules/shared/dataSharing/AssetDataFeesInternational.tsx